
import { ApiError, ApiResponse } from "../../types/global/apiTypes"
import { ConfigureLoginForm, Empresa, LoginAvailableForm, LoginForm, LoginResponse } from "../../types/global/UserAuthTypes"
import { axiosInstance } from "../axiosInstance"
import { handleAxiosResponse } from "../handleAxiosResponse"
import { UserNotificationResponse } from "../../common/domain/models/user_notification"

import handleAxiosError from "../handleAxiosError"

export const configureLogin = async (form: ConfigureLoginForm): Promise<ApiResponse<null>> => {
  try {
    const response = await axiosInstance().post(`/usuario/configure`, form)
    return handleAxiosResponse<null>(response)
  } catch (error) {
    return handleAxiosError(error)
  }
}

export const login = async (form: LoginForm): Promise<ApiResponse<LoginResponse>> => {
  try {
    const response = await axiosInstance().post(`/usuario/login`, form)
    return handleAxiosResponse<LoginResponse>(response)
  } catch (error) {
    return handleAxiosError(error)
  }
}

export const logout = async (): Promise<ApiResponse<null>> => {
  try {
    const response = await axiosInstance().post(`/usuario/logout`)
    return handleAxiosResponse<null>(response)
  } catch (error) {
    return handleAxiosError(error)
  }
}

export const loginAvailable = async (form: LoginAvailableForm): Promise<ApiResponse<string>> => {
  try {
    const response = await axiosInstance().post<string | ApiError>(`/usuario/login-available`, form)
    return handleAxiosResponse<string>(response)
  } catch (error) {
    return handleAxiosError(error)
  }
}

export const getEmpresas = async (): Promise<ApiResponse<Empresa[]>> => {
  try {
    const response = await axiosInstance().get<Empresa[] | ApiError>(`/empresa`)
    return handleAxiosResponse<Empresa[]>(response)
  } catch (error) {
    return handleAxiosError(error)
  }
}

export const getNotifications = async (signal?: AbortSignal): Promise<ApiResponse<UserNotificationResponse>> => {
  try {
    const response = await axiosInstance().get<UserNotificationResponse | ApiError>(`/usuario/notificacoes`, { signal, timeout: 30000 })
    return handleAxiosResponse<UserNotificationResponse>(response)
  } catch (error) {
    return handleAxiosError(error)
  }
}
